import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { ReducedMotionProvider } from './hooks/usePrefersReducedMotion'
import { AuthProvider } from './lib/auth'
import { AdminAuthProvider } from './lib/adminAuth'
import { I18nProvider } from './lib/i18n'
import App from './App.jsx'
import './index.css'

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.2 : 1.0,
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ReducedMotionProvider>
        <AuthProvider>
          <AdminAuthProvider>
            <I18nProvider>
              <App />
            </I18nProvider>
          </AdminAuthProvider>
        </AuthProvider>
      </ReducedMotionProvider>
    </BrowserRouter>
  </React.StrictMode>
)
